import { useContext, useEffect, useState } from "react";
import useSession from "../hooks/useSession";
import projectAPI from "../services/project";
import { UserContext } from "../context/UserContext";

const CollaboratorsModal = ({ idProject, onClose }) => {
  const { user, getL10nInstance } = useContext(UserContext)

  const [participants, setParticipants] = useState([]);
  const [l10n, setL10n] = useState(null)

  const [session] = useSession();

  useEffect(() => {
    (async () => {
      const instance = await getL10nInstance()
      setL10n(instance)
    })()
  }, [session, user])

  useEffect(() => {
    (async () => {
      try {
        const hashProject = await projectAPI.project({
          jwt: session,
          idProject,
        });
        const hash = hashProject.data.data.hash_id_project;
        getParticipants(hash);
      } catch (error) {
        console.error(error);
        onClose();
      }
    })();
  }, []);

  const getParticipants = async (hash) => {
    const res = await projectAPI.participants({ jwt: session, hash });
    const parcedParticipants = res.data.data.roles.map((item) => {
      return {
        hash_role: item.hash_id_role,
        email: item.email,
        role: item.type == "manager" ? "collaborator" : item.type,
        is_am: item.position == "am" ? true : false,
      };
    });
    setParticipants(parcedParticipants);
  };

  return (
    <>
      <div className="fixed inset-x-0 px-4 py-6 inset-0 flex items-center justify-center z-50">
        <div className="fixed inset-0 transition-opacity" onClick={onClose}>
          <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>

        <div className="relative bg-white rounded overflow-hidden shadow-xl transform transition-all sm:max-w-lg sm:w-full max-h-full p-4">
          {/* Close button */}
          <button
            onClick={onClose}
            className="absolute right-2 top-2 p-1 hover:bg-vanilla-100 text-graphite-100 text-sm rounded-md"
          >
            X
          </button>

          <h1 className="font-bold text-2xl text-center mb-4">{l10n && l10n.getString('Collaborators')}</h1>
          <div>
            {participants.map((participant, index) =>
              <div
                key={index}
                className="flex items-center justify-between my-2"
              >
                <p className="font-helveticaNeue">
                  {participant.email}
                </p>
                <p className="bg-[#F6F6F6] font-helveticaNeue h-6 rounded-[25px] px-3 pt-[2px] pb-1 font-bold text-[12px] text-[#734D85] ml-2 capitalize">{l10n && (participant.is_am ? l10n.getString('Account manager') : l10n.getString(participant.role))}</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default CollaboratorsModal;
